import React from "react";
import imageUrlBuilder from '@sanity/image-url'
import { PortableText } from "next-sanity";
import { formatDate } from "../functions/formatDate";
import { BsCalendar3 } from "react-icons/bs";

export default function ShareCard({title, text, date}){
    
    return <>
            <p><BsCalendar3 /> <i>Last updated: {title}</i></p>
            <div className="now-card">
                <PortableText 
                    value={text}
                />
            </div>
            
        </>
}